import React from 'react';
import styled, { css } from 'styled-components';
import { Box } from '../Box';
import { Icon } from '../Icon';
import { Text } from '../Text';
import { useTimeout } from '../hooks';
import { theme } from '../theme';
const styles = {
    upsell: {
        iconColor: 'liquorice',
        backgroundColor: theme.colors.marshmallowPink,
        textColor: 'liquorice',
    },
    critical: {
        iconColor: 'cream',
        backgroundColor: theme.colors.strawberry,
        textColor: 'cream',
    },
    general: {
        iconColor: 'cream',
        backgroundColor: theme.colors.liquorice,
        textColor: 'cream',
    },
    success: {
        iconColor: 'cream',
        backgroundColor: theme.colors.apple,
        textColor: 'cream',
    },
};
export const BannerItem = ({ type, autoCloseTime = 4, id, message, topOffset, exploreAction, showExploreText, showExploreIcon, leadingIcon, canManuallyClose, showCloseIcon, deleteBanner, noTimeout, }) => {
    const autoCloseBaner = () => {
        if (noTimeout)
            return;
        if (type !== 'critical')
            return deleteBanner(id);
        else {
            return;
        }
    };
    useTimeout(() => autoCloseBaner(), autoCloseTime * 1000);
    const textColor = styles[type].textColor;
    const iconColor = styles[type].iconColor;
    return (React.createElement(BannerWrapper, { p: "24px", mt: { custom: topOffset }, key: id, flex: true, justifyContent: "space-between", "$type": type },
        React.createElement(Box, { flex: true, alignItems: "center" },
            leadingIcon && (React.createElement(Icon, { mr: "12px", render: leadingIcon, size: 24, color: iconColor })),
            React.createElement(Text, { typo: "headline-small", color: textColor }, message)),
        React.createElement(Box, { flex: true, alignItems: "center" },
            canManuallyClose && (React.createElement(GenericButton, { onClick: () => deleteBanner(id), "aria-label": `close banner ${message}` }, showCloseIcon ? (React.createElement(Icon, { render: "cross", size: 16, color: iconColor })) : (React.createElement(UnderlinedText, { tag: "span", typo: "headline-small", color: textColor }, "Dismiss")))),
            exploreAction && (React.createElement(GenericButton, { onClick: exploreAction, "aria-label": `cta ${message}` },
                React.createElement(Box, { flex: true, alignItems: "center" },
                    showExploreText && (React.createElement(UnderlinedText, { ml: "12px", tag: "span", typo: "headline-small", color: textColor }, "Explore")),
                    showExploreIcon && (React.createElement(Icon, { render: "arrow", ml: "12px", size: 24, color: iconColor, rotate: 180 }))))))));
};
const BannerWrapper = styled(Box)(({ $type }) => css `
    border-radius: 0px 0px 16px 16px;
    background-color: ${styles[$type].backgroundColor};
  `);
const GenericButton = styled.button `
  cursor: pointer;
`;
const UnderlinedText = styled(Text) `
  text-decoration: underline;
`;
//# sourceMappingURL=BannerItem.js.map